import { render } from "./PublicationSearchResults.vue?vue&type=template&id=37c2d791&scoped=true"
import script from "./PublicationSearchResults.vue?vue&type=script&lang=js"
export * from "./PublicationSearchResults.vue?vue&type=script&lang=js"

import "./PublicationSearchResults.vue?vue&type=style&index=0&id=37c2d791&lang=scss&scoped=true"

import exportComponent from "C:\\Jenkins\\workspace\\BT5\\rptrweb\\release-RPTRWEB-3586\\client\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-37c2d791"]])

export default __exports__